// Stylized SVG portraits, one per crew id. Same 80×80 viewBox, designed to
// sit in a circular locket frame. Each is hand-shaped from primitive shapes —
// no external assets. Color palette pulls from --crew-hue so portraits tint
// with the locket's archetype color.
const PORTRAITS = {
    // Quartermaster — eyepatch + ledger
    quartermaster: `
    <circle cx="40" cy="44" r="22" fill="#e8d3a8"/>
    <path d="M22 30 Q40 14 58 30 L58 38 Q40 32 22 38 Z" fill="#3a2412"/>
    <rect x="20" y="48" width="14" height="3" fill="#1a1208"/>
    <line x1="20" y1="44" x2="34" y2="48" stroke="#1a1208" stroke-width="2"/>
    <circle cx="48" cy="48" r="3.5" fill="#1a1208"/>
    <path d="M30 58 Q40 62 50 58" stroke="#3a2412" stroke-width="2" fill="none"/>
    <rect x="60" y="50" width="14" height="18" fill="#8b6432" stroke="#1a1208"/>
    <line x1="62" y1="55" x2="72" y2="55" stroke="#1a1208" stroke-width="0.8"/>
    <line x1="62" y1="59" x2="72" y2="59" stroke="#1a1208" stroke-width="0.8"/>
    <line x1="62" y1="63" x2="72" y2="63" stroke="#1a1208" stroke-width="0.8"/>
  `,
    // Powder Monkey — small kid with smoking fuse
    powder_monkey: `
    <circle cx="40" cy="48" r="18" fill="#e8d3a8"/>
    <path d="M24 38 Q40 22 56 38 L56 50 Q40 44 24 50 Z" fill="#a83232"/>
    <circle cx="34" cy="48" r="2.2" fill="#1a1208"/>
    <circle cx="46" cy="48" r="2.2" fill="#1a1208"/>
    <path d="M34 56 Q40 60 46 56" stroke="#1a1208" stroke-width="1.5" fill="none"/>
    <rect x="55" y="22" width="4" height="14" fill="#3a2412" transform="rotate(20 57 29)"/>
    <circle cx="60" cy="20" r="3" fill="#f0c75a" opacity="0.85"/>
    <circle cx="62" cy="17" r="2" fill="#f8e88a" opacity="0.7"/>
  `,
    // Bosun — bearded, whistle, cap
    bosun: `
    <circle cx="40" cy="46" r="22" fill="#e8d3a8"/>
    <ellipse cx="40" cy="34" rx="22" ry="6" fill="#1a3a4a"/>
    <rect x="18" y="34" width="44" height="3" fill="#0a1a25"/>
    <circle cx="32" cy="46" r="2.5" fill="#1a1208"/>
    <circle cx="48" cy="46" r="2.5" fill="#1a1208"/>
    <path d="M28 56 Q40 70 52 56 Q48 64 40 64 Q32 64 28 56 Z" fill="#9b9b9b"/>
    <rect x="58" y="50" width="12" height="3" fill="#c69b3c"/>
    <circle cx="70" cy="51.5" r="2" fill="#c69b3c"/>
  `,
    // Cabin Boy — cap, freckles
    cabin_boy: `
    <circle cx="40" cy="48" r="18" fill="#f0d9b0"/>
    <path d="M22 38 Q40 22 58 38 L58 44 Q40 38 22 44 Z" fill="#3a5a8a"/>
    <rect x="22" y="44" width="36" height="2" fill="#1a2e4a"/>
    <circle cx="33" cy="48" r="2" fill="#1a1208"/>
    <circle cx="47" cy="48" r="2" fill="#1a1208"/>
    <circle cx="30" cy="52" r="0.6" fill="#7a4030"/>
    <circle cx="34" cy="55" r="0.6" fill="#7a4030"/>
    <circle cx="46" cy="55" r="0.6" fill="#7a4030"/>
    <circle cx="50" cy="52" r="0.6" fill="#7a4030"/>
    <path d="M34 60 Q40 64 46 60" stroke="#1a1208" stroke-width="1.5" fill="none"/>
  `,
    // Cooper — barrels behind him
    cooper: `
    <ellipse cx="22" cy="60" rx="10" ry="14" fill="#8b6432"/>
    <ellipse cx="22" cy="60" rx="10" ry="2" fill="#5a3a1a"/>
    <ellipse cx="22" cy="55" rx="10" ry="1.5" fill="#5a3a1a"/>
    <ellipse cx="22" cy="65" rx="10" ry="1.5" fill="#5a3a1a"/>
    <ellipse cx="60" cy="60" rx="10" ry="14" fill="#8b6432"/>
    <ellipse cx="60" cy="60" rx="10" ry="2" fill="#5a3a1a"/>
    <ellipse cx="60" cy="55" rx="10" ry="1.5" fill="#5a3a1a"/>
    <circle cx="40" cy="40" r="18" fill="#e8d3a8"/>
    <path d="M22 30 Q40 18 58 30 Q56 36 40 36 Q24 36 22 30 Z" fill="#3a2412"/>
    <circle cx="34" cy="42" r="2" fill="#1a1208"/>
    <circle cx="46" cy="42" r="2" fill="#1a1208"/>
    <path d="M34 50 Q40 54 46 50" stroke="#1a1208" stroke-width="1.5" fill="none"/>
  `,
    // Navigator — telescope to eye
    navigator: `
    <circle cx="38" cy="46" r="20" fill="#e8d3a8"/>
    <path d="M22 34 Q38 18 54 34 L54 42 Q38 36 22 42 Z" fill="#1a4040"/>
    <rect x="42" y="40" width="30" height="6" fill="#3a2412" rx="1" transform="rotate(-12 57 43)"/>
    <circle cx="44" cy="44" r="3" fill="#0a0a0a"/>
    <rect x="68" y="38" width="6" height="10" fill="#c69b3c" transform="rotate(-12 71 43)"/>
    <circle cx="32" cy="48" r="2" fill="#1a1208"/>
    <path d="M28 56 Q34 60 40 58" stroke="#1a1208" stroke-width="1.5" fill="none"/>
  `,
    // Cursed Compass — glowing needle, mystical
    cursed_compass: `
    <circle cx="40" cy="40" r="26" fill="#1a2030" stroke="#c69b3c" stroke-width="2"/>
    <circle cx="40" cy="40" r="20" fill="#0a1018"/>
    <text x="40" y="22" font-size="6" fill="#c69b3c" text-anchor="middle">N</text>
    <text x="60" y="42" font-size="6" fill="#c69b3c" text-anchor="middle">E</text>
    <text x="40" y="62" font-size="6" fill="#c69b3c" text-anchor="middle">S</text>
    <text x="20" y="42" font-size="6" fill="#c69b3c" text-anchor="middle">W</text>
    <path d="M40 40 L50 30 L40 25 L30 30 Z" fill="#a83232" opacity="0.95"/>
    <path d="M40 40 L50 30 L40 25 Z" fill="#f0c75a"/>
    <circle cx="40" cy="40" r="2" fill="#c69b3c"/>
    <circle cx="40" cy="40" r="30" fill="none" stroke="#c69b3c" stroke-width="0.5" opacity="0.4"/>
  `,
    // Kraken Banner — tentacles + flag
    kraken_banner: `
    <rect x="20" y="14" width="3" height="56" fill="#3a2412"/>
    <path d="M23 14 L70 14 L66 24 L70 34 L23 34 Z" fill="#1a1208" stroke="#c69b3c" stroke-width="0.8"/>
    <circle cx="46" cy="22" r="4" fill="#a83232"/>
    <circle cx="44" cy="20" r="1" fill="#0a0a0a"/>
    <circle cx="48" cy="20" r="1" fill="#0a0a0a"/>
    <path d="M30 26 Q34 30 32 34 Q36 32 38 36 Q40 30 44 32 Q48 28 50 32 Q54 30 58 34" stroke="#1a4040" stroke-width="2" fill="none"/>
    <path d="M14 50 Q22 56 28 52 Q34 60 42 54 Q50 60 56 54 Q62 60 70 56" stroke="#1a4040" stroke-width="3" fill="none"/>
    <path d="M16 60 Q24 66 30 62 Q38 68 46 62 Q54 68 60 62" stroke="#1a4040" stroke-width="3" fill="none"/>
  `,
    // Bilge Rat — rat in shadows
    bilge_rat: `
    <rect x="0" y="0" width="80" height="80" fill="#0a0a0a" opacity="0"/>
    <ellipse cx="40" cy="50" rx="22" ry="14" fill="#5a4a3a"/>
    <ellipse cx="58" cy="46" rx="10" ry="8" fill="#5a4a3a"/>
    <circle cx="62" cy="38" r="4" fill="#5a4a3a"/>
    <circle cx="65" cy="36" r="4" fill="#5a4a3a"/>
    <circle cx="60" cy="44" r="1.5" fill="#f0c75a"/>
    <circle cx="64" cy="42" r="1.5" fill="#f0c75a"/>
    <path d="M68 47 L72 47" stroke="#1a1208" stroke-width="0.6"/>
    <path d="M68 49 L72 49" stroke="#1a1208" stroke-width="0.6"/>
    <path d="M16 56 Q8 62 12 70 Q4 66 6 76" stroke="#3a2a1a" stroke-width="2.5" fill="none"/>
    <circle cx="68" cy="46" r="0.8" fill="#1a1208"/>
  `,
    // Parrot — colorful bird
    parrot: `
    <ellipse cx="40" cy="44" rx="16" ry="22" fill="#a83232"/>
    <ellipse cx="40" cy="36" rx="12" ry="14" fill="#1a4040"/>
    <ellipse cx="42" cy="46" rx="10" ry="14" fill="#c69b3c"/>
    <circle cx="36" cy="34" r="2.5" fill="#f0e8d0"/>
    <circle cx="36" cy="34" r="1.2" fill="#0a0a0a"/>
    <path d="M44 34 L54 36 L44 40 Z" fill="#f0c75a"/>
    <path d="M44 36 L52 38 L44 39 Z" fill="#1a1208"/>
    <path d="M50 60 Q56 70 52 76" stroke="#1a4040" stroke-width="3" fill="none"/>
    <path d="M28 50 Q22 56 24 64" stroke="#a83232" stroke-width="2" fill="none"/>
  `,
    // Gunner — cannon
    gunner: `
    <ellipse cx="20" cy="58" rx="6" ry="4" fill="#3a2412"/>
    <ellipse cx="60" cy="58" rx="6" ry="4" fill="#3a2412"/>
    <rect x="14" y="42" width="56" height="20" fill="#3a3a3a" rx="2"/>
    <rect x="14" y="42" width="56" height="4" fill="#1a1a1a"/>
    <circle cx="14" cy="52" r="6" fill="#1a1a1a"/>
    <circle cx="70" cy="52" r="3" fill="#0a0a0a"/>
    <circle cx="72" cy="50" r="2" fill="#3a3a3a"/>
    <circle cx="76" cy="48" r="3" fill="#f0c75a" opacity="0.9"/>
    <circle cx="78" cy="46" r="1.5" fill="#f8e88a"/>
    <path d="M14 38 L18 30 L20 34 L24 26 L26 32" stroke="#c69b3c" stroke-width="1.5" fill="none"/>
  `,
    // Smuggler — hooded, sack of coins
    smuggler: `
    <path d="M40 18 Q22 24 22 44 L22 70 L58 70 L58 44 Q58 24 40 18 Z" fill="#1a1208"/>
    <path d="M30 38 Q40 30 50 38 L50 50 Q40 44 30 50 Z" fill="#1a1208"/>
    <ellipse cx="40" cy="50" rx="10" ry="8" fill="#3a2412"/>
    <circle cx="36" cy="48" r="1.2" fill="#f0c75a"/>
    <circle cx="44" cy="48" r="1.2" fill="#f0c75a"/>
    <ellipse cx="62" cy="62" rx="10" ry="8" fill="#8b6432" stroke="#3a2412" stroke-width="1"/>
    <path d="M58 56 Q62 52 66 56" stroke="#3a2412" stroke-width="2" fill="none"/>
    <circle cx="60" cy="62" r="2" fill="#f0c75a"/>
    <circle cx="64" cy="64" r="2" fill="#c69b3c"/>
    <circle cx="62" cy="58" r="1.5" fill="#f0c75a"/>
  `,
};
export function renderCrewPortrait(crewId) {
    const portrait = PORTRAITS[crewId];
    if (!portrait)
        return '<text x="40" y="50" font-size="40" text-anchor="middle">?</text>';
    return portrait;
}
export function hasCrewPortrait(crewId) {
    return crewId in PORTRAITS;
}
